<template>
  <v-card class="ma-6 pa-6">
    <v-row class="changePassword no-gutters pb-10">
      <v-col cols="12 mb-5">
        <h3 class="text-center" @submit.prevent="Submit">Change Password</h3>
      </v-col>
      <v-col cols="12">
        <v-row class="d-flex align-center flex-column no-gutters">
          <v-col cols="4 ">
            <v-text-field
              v-model="password"
              :rules="passwordRules"
              @click:append="show1 = !show1"
              :type="show1 ? 'text' : 'password'"
              :append-icon="!show1 ? 'visibility_off' : 'visibility'"
              class="v-label theme--light error--text"
              label="New Password"
            ></v-text-field>
          </v-col>
          <v-col cols="4 ">
            <v-text-field
              v-model.trim.lazy="cPassword"
              :rules="[password === cPassword || 'Password doesnot match']"
              @click:append="show2 = !show2"
              :type="show2 ? 'text' : 'Password'"
              label="Confirm Password"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn
              depressed
              class="primary_btn small mr-4"
              :loading="saveBtnLoading"
              :disabled="!checkPasswordsMatch"
              @click="checkPasswordsMatch && submit()"
              >Submit</v-btn
            >

            <v-btn
              depressed
              @click="$router.push({ name: 'profileEdit' })"
              class="secondary_btn small"
              >Cancel</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { resetPasswordRules } from '@/support/utils/form-rules';
import { resetPasswordPattern } from '@/support/utils/patterns';
import { mapActions } from 'vuex';
import { storeActions } from '@/store/actions.constants';

export default {
  data: () => ({
    show1: false,
    show2: false,
    password: '',
    cPassword: '',
    valid: true,
    saveBtnLoading: false,
    passwordRules: resetPasswordRules,
    passpattern: resetPasswordPattern,
    input: {
      password: null,
      cPassword: null,
    },
  }),
  computed: {
    checkPasswordsMatch() {
      if (
        !!this.password &&
        this.passpattern.test(this.password) &&
        this.password === this.cPassword
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    ...mapActions({
      changePassword: 'users/changePassword',
    }),

    async submit() {
      // axios.post(`/user/changeUserPassword`,this.values)
      // .then((response)=> console.log(response))
      // .catch((error)=>console.log(error))
      this.saveBtnLoading = true;
      const payload = {
        password: this.password.trim(),
        cPassword: this.cPassword.trim(),
      };

      this.changePassword(payload).then((res) => {
        if (res && res.status === 200) {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: 'Successfully changed password',
            timeout: 1000,
            color: 'success',
          });
          this.saveBtnLoading = false;
          localStorage.clear();
          this.$router.push('/');
        } else {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: 'Error changing password',
            timeout: 1000,
            color: 'error',
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.changePassword {
  width: 100%;
}
</style>
